// extracted by mini-css-extract-plugin
export default {"venchyFixedSide":"venchySpeaking_venchyFixedSide__Murv1","image":"venchySpeaking_image__nw5oi"};